import LoanMovements from "./LoanMovements.jsx";

export default LoanMovements;
